module.exports = __webpack_public_path__ + "img/refund.59cb7e33.svg";